<template>
  <div id="app">
    <TargetCalculator :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import TargetCalculator from "./components/TargetCalculator.vue";

export default {
  name: "App",
  components: {
    TargetCalculator,
  },
};
</script>

<style>
#app {
}
</style>
